import { render, staticRenderFns } from "./table_view.vue?vue&type=template&id=03faf61e&scoped=true&"
import script from "./table_view.vue?vue&type=script&lang=ts&"
export * from "./table_view.vue?vue&type=script&lang=ts&"
import style0 from "./table_view.vue?vue&type=style&index=0&id=03faf61e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03faf61e",
  null
  
)

export default component.exports